import React from "react";
import "./Intro.css";
import Projects from "../../Works/AllWork.json";

const Intro = props => {
  const currentProject = Projects.filter(
    project => project.projectId === +props.projectId
  );
  const imageSource = currentProject[0].projectLargeImage;
  return (
    <div id="single-intro-container" className="row">
      <img src={imageSource} />
      <div className="mission col-xs-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-8 offset-lg-3 col-xl-7 offset-xl-3 p-5">
        {Projects.map((project, index) => {
          return project.projectId === +props.projectId ? (
            <div key={project.projectId}>
              <div id="brand">{project.projectName}</div>
              <div className="mission">{project.projectDescription}</div>
            </div>
          ) : null;
        })}
      </div>
    </div>
  );
};

export default Intro;



// WEBPACK FOOTER //
// ./src/components/SingleProject/Intro/Intro.js